import React, { useState, useEffect, useRef } from "react";
import "./HRChallenges.css";
// import { useSelector } from "react-redux"; // Unused import
import { useUserTokenSelector } from "store/reducers";
import axios from "axios";
import Loading from "../../components/Utilities/Loading/Loading";
import { GrDownload } from "react-icons/gr";
// import { IoMdTrendingUp } from "react-icons/io"; // Unused import
// import { IoMdTrendingDown } from "react-icons/io"; // Unused import
import { FaChevronLeft, FaChevronRight } from "react-icons/fa6";
import { CiCircleInfo } from "react-icons/ci";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Cell,
  ResponsiveContainer,
} from "recharts"; // Removed Legend as it's not used
import { Progress } from "antd";
import { useInView } from "react-intersection-observer";
import {
  getChallengeAllDetails,
  getChallengeAnalysisData,
  getLeaderboardData,
} from "actions/assessment";
import { getLeaderboard } from "actions/challenges";
import { startLoading, stopLoading } from "store/actions";
import { useDispatch } from "react-redux";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { Template } from "Containers/Overview/template";

export const HRChallenges = ({ adminCorporateId }) => {
  // Removed history as it's not used
  const token = useUserTokenSelector();
  const [error, setError] = useState("");
  // Filter states
  const [selectTimeRange, setSelectTimeRange] = useState("all");
  // Intersection observer states for chart animations
  const [isTeamActive, setIsTeamActive] = useState(false);
  const [isCmpActive, setIsCmpActive] = useState(false);
  const [isDailyStepsActive, setIsDailyStepsActive] = useState(false);
  const [showCustomCalendar, setShowCustomCalendar] = useState(false);
  const [customDateRange, setCustomDateRange] = useState(null);

  const dispatch = useDispatch();
  // State for data fetched from APIs
  const [apiChallengeAnalysisData, setApiChallengeAnalysisData] =
    useState(null); // For general challenge analysis (charts)
  const [apiAllChallengeDetails, setApiAllChallengeDetails] = useState([]); // Holds all challenges for the top cards carousel
  const [currentChallengeDisplayIndex, setCurrentChallengeDisplayIndex] =
    useState(0); // Index for the current challenge in carousel
  const [apiCurrentChallengeInfo, setApiCurrentChallengeInfo] = useState(null); // Data for the currently displayed challenge in top cards
  const [apiLeaderboardData, setApiLeaderboardData] = useState(null); // Leaderboard data for the current challenge
  const [showReport, setShowReport] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);

  const [userInfo, setUserInfo] = useState({
    signups: {
      total: 0,
      previous: 0,
    },
    active: {
      total: 0,
      previous: 0,
    },
    logins: {
      total: 0,
      previous: 0,
    },
  });

  const [uniqueUsers, setUniqueUsers] = useState("");
  const [genderChartData, setGenderChartData] = useState([]);
  const [signedUpUsers, setSignedUpUsers] = useState("");
  const [monthlyLoginData, setMonthlyLoginData] = useState([]);
  const [currMonthSessionCount, setCurrMonthSessionCount] = useState("");
  const [sessionCountChange, setSessionCountChange] = useState("");
  const [uniqueUserChange, setUniqueUserChange] = useState("");

  // Colors for charts
  const colors = ["#49AF7C", "#89D4AF", "#C4EED9", "#DCF6E9"];
  const colors2 = ["#7E8ED9", "#B4BDE9", "#CBD1F0", "#E8EBFF"];

  // Static fallback data (can be minimized or removed if API reliability and loading states are sufficient)
  const participationInfoStatic = {
    stepChallenge: { total: 80, previous: 70 },
    avgSteps: { total: 5868 },
    goal: { total: 70 },
  };
  const leaderboardDataStatic = [
    {
      rank: 1,
      name: "Amit",
      gender: "male",
      dailyAvgSteps: 1200,
      totalSteps: 1200,
      days: 10,
    },
    // Add more static leaderboard entries if needed for fallback
  ];
  const teamWiseStepsStatic = [
    { teamName: "Sales", value: 5000 },
    // Add more static team steps if needed
  ];
  const challengeCmpStatic = [
    { team: "Sales", step: 90, detox: 90 },
    // Add more static comparison data if needed
  ];

  // Time range filter configuration
  const timeRangeMap = new Map([
    ["Today", "today"],
    ["This Week", "7d"],
    ["This Month", "30d"],
    ["Last 3 months", "3m"],
    ["Last 6 months", "6m"],
    ["Last Year", "lastYear"],
    ["This Year", "1y"],
    ["All Time", "all"],
    ["Custom", "custom"],
  ]);
  const timeRangeArray = [
    "All Time",
    "Today",
    "This Week",
    "This Month",
    "Last 3 months",
    "Last 6 months",
    "Last Year",
    "This Year",
    "Custom",
  ];

  const handleTimeRangeChange = (e) => {
    const value = e.target.value;
    setSelectTimeRange(value);
    if (value === "custom") {
      setShowCustomCalendar(true);
    } else {
      setShowCustomCalendar(false);
    }
  };

  const handleCustomDateChange = (date) => {
    if (Array.isArray(date)) {
      const [startDate, endDate] = date;
      setCustomDateRange([startDate, endDate]);
      if (startDate && endDate) {
        setShowCustomCalendar(false);
      }
      return;
    }
    setCustomDateRange(date);
  };

  const getCustomDates = () => {
    if (Array.isArray(customDateRange)) {
      const [startDate, endDate] = customDateRange;
      return { startDate, endDate, singleDate: startDate };
    }
    return { startDate: null, endDate: null, singleDate: customDateRange };
  };

  function mapTimeRangeToApiValue(timeRange) {
    return timeRangeMap.get(timeRange) || "all";
  }

  // Intersection observer for team-wise steps chart
  const [teamRef, teamInView] = useInView({ threshold: 0.7 });
  useEffect(() => {
    if (teamInView) setIsTeamActive(true);
  }, [teamInView]);

  // Intersection observer for comparison chart
  const [cmpRef, cmpInView] = useInView({ threshold: 0.7 });
  useEffect(() => {
    if (cmpInView) setIsCmpActive(true);
  }, [cmpInView]);

  // Intersection observer for daily steps chart
  const [dailyStepsRef, dailyStepsInView] = useInView({ threshold: 0.7 });
  useEffect(() => {
    if (dailyStepsInView) setIsDailyStepsActive(true);
  }, [dailyStepsInView]);

  // Helper to format date for XAxis display (e.g., "DD/MM")
  const formatDateForDisplay = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return `${date.getDate()}/${date.getMonth() + 1}`;
  };

  // Helper function to transform API comparison data for the UI
  const transformComparisonData = (teamComparison) => {
    if (
      !teamComparison ||
      !teamComparison.ongoingChallenge ||
      !teamComparison.ongoingChallenge.teamPercentages ||
      !teamComparison.expiredChallenge ||
      !teamComparison.expiredChallenge.teamPercentages
    ) {
      return challengeCmpStatic; // Fallback to static if data is incomplete
    }
    return teamComparison.ongoingChallenge.teamPercentages.map(
      (ongoingTeam) => {
        const expiredTeamData =
          teamComparison.expiredChallenge.teamPercentages.find(
            (exTeam) => exTeam.teamName === ongoingTeam.teamName
          );
        const ongoingPercentage = Number(ongoingTeam.value) || 0;
        const expiredPercentage = expiredTeamData
          ? Number(expiredTeamData.value) || 0
          : 0;
        return {
          team: ongoingTeam.teamName,
          step: ongoingPercentage,
          detox: expiredPercentage,
          ongoingChallengeName: teamComparison.ongoingChallenge.challengeName,
          expiredChallengeName: teamComparison.expiredChallenge.challengeName,
        };
      }
    );
  };

  // Fetches general challenge analysis data for charts
  const fetchChallengeAnalysisData = async () => {
    if (!token) return;
    // dispatch(startLoading()); // Removed: Handled by the main useEffect's Promise.all

    let apiTimeRange = selectTimeRange;
    let startDate = null;
    let endDate = null;

    try {
      const res = await getChallengeAnalysisData(token, apiTimeRange, customDateRange);
      setApiChallengeAnalysisData(res.data.data);
    } catch (err) {
      console.error("Error fetching challenge analysis data:", err);
      // setError("Failed to load challenge analysis."); // Optionally set specific error for this part
    }
    // dispatch(stopLoading()); // Removed: Handled by the main useEffect's Promise.all
  };

  // Fetches details for challenges to be displayed in the top cards carousel
  const fetchCurrentChallengeInformationData = async () => {
    if (!token) return;
    // dispatch(startLoading()); // Removed: Handled by the main useEffect's Promise.all

    let apiTimeRange = selectTimeRange;
    let startDate = null;
    let endDate = null;

    try {
      const res = await getChallengeAllDetails(token, apiTimeRange, customDateRange);
      if (res.data.status === "success" && Array.isArray(res.data.data)) {
        setApiAllChallengeDetails(res.data.data);
      } else {
        setApiAllChallengeDetails([]);
        setApiCurrentChallengeInfo(null);
      }
    } catch (err) {
      console.error("Error fetching current challenge info:", err);
      // setError("Failed to load challenge details."); // Optionally set specific error for this part
    }
    // dispatch(stopLoading()); // Removed: Handled by the main useEffect's Promise.all
  };

  // Effect to update the displayed challenge in top cards and fetch its leaderboard
  useEffect(() => {
    if (apiAllChallengeDetails.length > 0) {
      // Ensure index is within bounds
      const newIndex = Math.min(
        currentChallengeDisplayIndex,
        apiAllChallengeDetails.length - 1
      );
      if (newIndex !== currentChallengeDisplayIndex) {
        setCurrentChallengeDisplayIndex(newIndex); // Adjust index if out of bounds
      }
      const challengeToDisplay = apiAllChallengeDetails[newIndex];
      setApiCurrentChallengeInfo(challengeToDisplay);
      setApiLeaderboardData(null);
      if (challengeToDisplay?.challenge?._id) {
        const { startDate, endDate } = getCustomDates();
        const isCustomDateValid =
          selectTimeRange !== "custom" || (startDate && endDate);
  
        if (!isCustomDateValid) return;
        fetchLeaderboardData(challengeToDisplay.challenge._id);
      }
    } else {
      // Reset if no challenges are available
      setApiCurrentChallengeInfo(null);
      setApiLeaderboardData(null);
      setCurrentChallengeDisplayIndex(0); // Reset index if no challenges
    }
  }, [apiAllChallengeDetails, currentChallengeDisplayIndex, selectTimeRange, customDateRange]); // currentChallengeDisplayIndex dependency is important here

  // Fetches leaderboard data for a specific challenge ID
  const fetchLeaderboardData = async (challengeId) => {
    if (!token || !challengeId) return;
    // dispatch(startLoading());

    let apiTimeRange = selectTimeRange;
    let startDate = null;
    let endDate = null;

    try {
      const res = await getLeaderboardData(token, challengeId, apiTimeRange, customDateRange);
      if (res.data.status === "success") {
        setApiLeaderboardData(res.data.data.leaderboard || res.data.data);
      } else {
        setError((prev) => prev + " Failed to fetch leaderboard data.");
        setApiLeaderboardData(null);
      }
    } catch (err) {
      console.error("Error fetching leaderboard data:", err);
      setApiLeaderboardData(null);
    }
    // dispatch(stopLoading());
  };

  // Main data fetching effect, runs when filters change
  useEffect(() => {
    dispatch(startLoading()); // Dispatch global startLoading action
    setError("");
    setCurrentChallengeDisplayIndex(0); // Reset carousel to the first challenge

    const { startDate, endDate } = getCustomDates();
    const isCustomDateValid =
      selectTimeRange !== "custom" || (startDate && endDate);
  
    if (!isCustomDateValid) return;
    Promise.all([
      fetchChallengeAnalysisData(),
      fetchCurrentChallengeInformationData(),
    ])
      .catch((err) => {
        console.error("Error during combined challenge data fetch:", err);
        setError("Failed to load challenge data. Please try again.");
      })
      .finally(() => {
        dispatch(stopLoading()); // Dispatch global stopLoading action
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [adminCorporateId, token, selectTimeRange, customDateRange]); // Dependencies for re-fetching

  // Handlers for challenge carousel navigation
  const handleNextChallengeDisplay = () => {
    if (apiAllChallengeDetails.length === 0) return;
    setCurrentChallengeDisplayIndex((prevIndex) =>
      prevIndex + 1 >= apiAllChallengeDetails.length ? 0 : prevIndex + 1
    );
  };
  const handlePreviousChallengeDisplay = () => {
    if (apiAllChallengeDetails.length === 0) return;
    setCurrentChallengeDisplayIndex((prevIndex) =>
      prevIndex - 1 < 0 ? apiAllChallengeDetails.length - 1 : prevIndex - 1
    );
  };

  const hrChallengesData = () => {
    const dataJson = {
      signups: userInfo.signups,
      active: userInfo.active,
      logins: userInfo.logins,
      uniqueUsers: uniqueUsers,
      genderChartData: genderChartData,
      signedUpUsers: signedUpUsers,
      monthlyLoginData: monthlyLoginData,
      currMonthSessionCount: currMonthSessionCount,
      sessionCountChange: sessionCountChange,
      uniqueUserChange: uniqueUserChange,
      overviewItems: [],
      contentTrends: [],
      engagement: [],
      distribution: [],
      engagedEmp: [],
      apiChallengeAnalysisData: apiChallengeAnalysisData,
      apiAllChallengeDetails: apiAllChallengeDetails,
      apiCurrentChallengeInfo: apiCurrentChallengeInfo,
      apiLeaderboardData: apiLeaderboardData,
    };
    return dataJson;
  };

  const handleShowReport = () => {
    setIsDownloading(true);
    setShowReport(true);
    dispatch(startLoading());
  };

  const handleReportClose = () => {
    setIsDownloading(false);
    setShowReport(false);
    dispatch(stopLoading());
  };

  const isIndividualLeaderboard =
    apiCurrentChallengeInfo?.challenge?.leaderboardType === "individual";

  return (
    <div className="challenges">
      {showCustomCalendar && (
        <div
          className="challenges-overlay-background"
          onClick={() => setShowCustomCalendar(false)}
          aria-label="Close calendar"
        ></div>
      )}
        <>
          <div>
            <div className="challenges-top">
              {/* Filter and Download section */}
              <div className="overview-filter">
                <select
                  id="timeRangeFilter"
                  value={selectTimeRange}
                  // onChange={(e) => setSelectTimeRange(e.target.value)}
                  onChange={handleTimeRangeChange}
                >
                  {timeRangeArray.map((time, index) => (
                    <option key={index} value={mapTimeRangeToApiValue(time)}>
                      {time}
                    </option>
                  ))}
                </select>
              </div>
              <div className={`download-div ${isDownloading ? "disabled" : ""}`} onClick={!isDownloading ? handleShowReport : null}>
                <GrDownload />
                <span>Download</span>
              </div>
            </div>
            <div id="challenges">
              {showCustomCalendar && (
                <div className="custom-calendar-container">
                  <Calendar
                    onChange={handleCustomDateChange}
                    value={customDateRange}
                    selectRange
                  />
                </div>
              )}
              {/* Main content area for challenges */}
              <div className="challenges-divs">
                {/* Top row of challenge cards */}
                <div className="challenges-div">
                  {/* Participation Card */}
                  <div className="challenges-top">
                    <span
                      className="challenge-title-span"
                      data-testid="challenge-title-span"
                    >
                      {apiCurrentChallengeInfo?.challenge?.challengename ||
                        "Challenge"}{" "}
                      Participation
                    </span>
                  </div>
                  <div className="challenges-bottom" style={{display:'flex', flexDirection:'row', justifyContent:'space-between'}}>
                    {apiAllChallengeDetails.length >
                      1 /* Show left arrow if multiple challenges */ && (
                      <FaChevronLeft
                        size={25}
                        onClick={
                          currentChallengeDisplayIndex > 0
                            ? handlePreviousChallengeDisplay
                            : null
                        }
                        className={`challenge-nav-arrow-left ${
                          currentChallengeDisplayIndex === 0 ? "disabled" : ""
                        }`}
                      />
                    )}
                    <div className="progress-div">
                      <Progress
                        type="circle"
                        percent={
                          apiCurrentChallengeInfo
                            ? parseFloat(
                                apiCurrentChallengeInfo.averageParticipation *
                                  100
                              ).toFixed(0)
                            : participationInfoStatic.stepChallenge.total
                        }
                        strokeColor={"#49AF7C"}
                        strokeWidth={12}
                      />
                    </div>
                    {apiAllChallengeDetails.length > 1 &&
                      currentChallengeDisplayIndex <
                        apiAllChallengeDetails.length -
                          1 /* Show right arrow */ && (
                        <FaChevronRight
                          size={25}
                          onClick={handleNextChallengeDisplay}
                          className="challenge-nav-arrow-right"
                          data-testid="challenge-nav-arrow-right"
                        />
                      )}
                  </div>
                </div>
                <div className="challenges-div">
                  {/* Average Value Card */}
                  <div className="challenges-top">
                    <span
                      className="challenge-title-span"
                      data-testid="challenge-average-cal-span"
                    >
                      Average{" "}
                      {apiCurrentChallengeInfo?.challenge?.challengename?.replace(
                        / Challenge$/,
                        ""
                      ) || "Value"}
                    </span>
                  </div>
                  <div className="challenges-bottom avg-steps">
                    <img
                      src="https://ucarecdn.com/ee312e2b-f9be-4d99-8e5f-429d79571787/stepsimg.png"
                      alt="Average steps icon"
                    />
                    <p>
                      {apiCurrentChallengeInfo
                        ? parseFloat(
                            apiCurrentChallengeInfo.averageValue
                          ).toFixed(0)
                        : participationInfoStatic.avgSteps.total}
                    </p>
                  </div>
                </div>
                <div className="challenges-div">
                  {/* Goal Completion Card */}
                  <div className="challenges-top">
                    <span className="challenge-title-span">
                      Avg. Daily Goal Completion
                    </span>
                  </div>
                  <div className="challenges-bottom">
                    <div className="progress-div">
                      <Progress
                        type="circle"
                        percent={
                          apiCurrentChallengeInfo
                            ? parseFloat(
                                apiCurrentChallengeInfo.averageCompletionRate *
                                  100
                              ).toFixed(0)
                            : participationInfoStatic.goal.total
                        }
                        strokeColor={"#49AF7C"}
                        strokeWidth={12}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="leaderboard-div">
                {/* Leaderboard Section */}
                <div className="leaderboard-top">
                  <div className="leaderboard-tleft">
                    <img
                      src="https://ucarecdn.com/e39edccf-47aa-46a5-9356-ed1003b3d3f4/prize.png"
                      alt="Prize icon"
                    />
                    <p>Leaderboard</p>
                    <img
                      src="https://ucarecdn.com/e39edccf-47aa-46a5-9356-ed1003b3d3f4/prize.png"
                      alt="Prize icon"
                    />
                  </div>
                  <div className="leaderboard-tright">
                    <CiCircleInfo size={20} />
                  </div>
                </div>
                <div className="ltable-div">
                  <div className="ltable-head">
                    <div className="hrank">Rank</div>
                    <div className="hname">Team Name</div>
                    <div className="hasteps">
                      Average Daily{" "}
                      {(
                        apiCurrentChallengeInfo?.challenge?.challengename ||
                        "Value"
                      ).replace(/ Challenge$/, "")}
                    </div>
                    <div className="hsteps">
                      Total{" "}
                      {(
                        apiCurrentChallengeInfo?.challenge?.challengename ||
                        "Value"
                      ).replace(/ Challenge$/, "")}
                    </div>
                    <div className="hdays">Days Participated</div>
                  </div>
                  <div className="ltable-body">
                    {apiLeaderboardData && apiLeaderboardData.length > 0 ? (
                      [...apiLeaderboardData]
                        .sort((a, b) => a.newposition - b.newposition)
                        .map((data, index) => (
                          <div
                            className="ltable-box"
                            key={data.newposition || data.rank || index}
                          >
                            <div className="rank">
                              {(data.newposition || data.rank) === 1 ? (
                                <img
                                  src="https://ucarecdn.com/3306e177-28f6-43ea-807d-c015117dac92/first.png"
                                  alt="Rank 1"
                                />
                              ) : (data.newposition || data.rank) === 2 ? (
                                <img
                                  src="https://ucarecdn.com/a344e25e-71c9-47ce-904b-4de2bf824226/second.png"
                                  alt="Rank 2"
                                />
                              ) : (data.newposition || data.rank) === 3 ? (
                                <img
                                  src="https://ucarecdn.com/2d39e42a-af1a-487d-960d-de79464340cd/third.png"
                                  alt="Rank 3"
                                />
                              ) : (
                                <p>{data.newposition || data.rank}</p>
                              )}
                            </div>
                            <div className="name">
                              <p>
                                {isIndividualLeaderboard
                                  ? data.username || data.name
                                  : data.userTeamName || data.name}
                              </p>
                            </div>
                            <div className="asteps">
                              <p>
                                <span className="mobile-head">
                                  Average Daily Value:{" "}
                                </span>
                                {data.averageDailyValue || data.dailyAvgSteps}
                              </p>
                            </div>
                            <div className="steps">
                              <p>
                                <span className="mobile-head">
                                  Total Value:{" "}
                                </span>
                                {data.totalValue || data.totalSteps}
                              </p>
                            </div>
                            <div className="days">
                              <p>
                                <span className="mobile-head">
                                  Days Participated:{" "}
                                </span>
                                {data.participatedInDays || data.days}
                              </p>
                            </div>
                          </div>
                        ))
                    ) : (
                      <div style={{ textAlign: "center", padding: "20px" }}>
                        <p>No leaderboard data available</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="challenges-divs">
                {/* Bottom row of chart cards */}
                <div className="challenges-div graph">
                  {/* Team Wise Average Steps Chart */}
                  <div className="challenges-top">
                    <span>Team Wise Average Steps taken</span>
                    <CiCircleInfo />
                  </div>
                  <div style={{ height: "300px" }} ref={teamRef}>
                    <ResponsiveContainer width="100%" height="100%">
                      <BarChart
                        data={
                          apiChallengeAnalysisData?.teamAverageValue ||
                          teamWiseStepsStatic
                        }
                        barSize={45}
                      >
                        <CartesianGrid
                          strokeDasharray="3 3"
                          horizontal={true}
                          vertical={false}
                        />
                        <XAxis dataKey="teamName" tickLine={false}/>
                        <YAxis tickLine={false}/>
                        <Tooltip />
                        {isTeamActive && (
                          <Bar dataKey="value" name="Average Value">
                            {(
                              apiChallengeAnalysisData?.teamAverageValue ||
                              teamWiseStepsStatic
                            ).map((entry, index) => (
                              <Cell
                                key={`cell-${index}`}
                                fill={colors[index % colors.length]}
                              />
                            ))}
                          </Bar>
                        )}
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                </div>
                <div className="challenges-div graph">
                  {/* Daily Average Steps Chart */}
                  <div className="challenges-top">
                    <span>Daily average steps taken</span>
                    <CiCircleInfo />
                  </div>
                  <div
                    style={{ width: "100%", height: "300px" }}
                    ref={dailyStepsRef}
                  >
                    <ResponsiveContainer width="100%" height="100%">
                      <BarChart
                        data={
                          apiChallengeAnalysisData?.dailyParticipationRates ||
                          []
                        }
                        barSize={40}
                      >
                        <CartesianGrid
                          strokeDasharray="3 3"
                          horizontal={true}
                          vertical={false}
                        />
                        <XAxis
                          dataKey="_id"
                          tickLine={false}
                          tickFormatter={formatDateForDisplay}
                        />
                        <YAxis tickLine={false}/>
                        <Tooltip />
                        {isDailyStepsActive && (
                          <Bar dataKey="count" name="Participation Count">
                            {(
                              apiChallengeAnalysisData?.dailyParticipationRates ||
                              []
                            ).map((entry, index) => (
                              <Cell
                                key={`cell-daily-${index}`}
                                fill={colors2[index % colors2.length]}
                              />
                            ))}
                          </Bar>
                        )}
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                </div>
              </div>
              <div className="challenges-div cmp">
                  {/* Comparison Chart */}
                  <div className="challenges-top">
                    <span>Comparison with last challenge</span>
                    <CiCircleInfo />
                  </div>
                  <div className="cmp-head">
                    <p className="cmp-left">
                      {(apiChallengeAnalysisData?.teamComparision &&
                        transformComparisonData(
                          apiChallengeAnalysisData.teamComparision
                        )[0]?.ongoingChallengeName) ||
                        "Ongoing Challenge"}
                    </p>
                    <p className="cmp-name">vs</p>
                    <p className="cmp-right">
                      {(apiChallengeAnalysisData?.teamComparision &&
                        transformComparisonData(
                          apiChallengeAnalysisData.teamComparision
                        )[0]?.expiredChallengeName) ||
                        "Expired Challenge"}
                    </p>
                  </div>
                  <div className="cmp-divs" ref={cmpRef}>
                    {isCmpActive &&
                      (apiChallengeAnalysisData?.teamComparision
                        ? transformComparisonData(
                            apiChallengeAnalysisData.teamComparision
                          )
                        : challengeCmpStatic
                      ).map((challenge, index) => (
                        <div className="cmp-div" key={challenge.team || index}>
                          <div className="cmp-left">
                            <div
                              className="cmp-bar1"
                              style={{
                                width: `${challenge.step}%`,
                                backgroundColor: colors[index % colors.length],
                              }}
                            >
                              <div className="cmp-per1">
                                <p>{Math.round(challenge.step)}%</p>
                              </div>
                            </div>
                          </div>
                          <div className="cmp-name">
                            <p>{challenge.team} Team</p>
                          </div>
                          <div className="cmp-right">
                            <div
                              className="cmp-bar2"
                              style={{
                                width: `${challenge.detox}%`,
                                backgroundColor: colors2[index % colors.length],
                              }}
                            >
                              <div className="cmp-per1">
                                <p>{Math.round(challenge.detox)}%</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
            </div>
          </div>
        </>
      {showReport && <Template data={hrChallengesData()} close={handleReportClose} />}
    </div>
  );
};

export default HRChallenges;
